<template>
    <DForm @submit.prevent="submitForm">
        <DFormRow
            :label="__('settings.email_verification_settings.form.api_url')"
            :is-required="true"
            :error="errorsData.api_url"
            :hint="__('settings.email_verification_settings.form.api_url_hint')"
        >
            <DInput
                id="api_url"
                v-model="form.api_url"
                :placeholder="__('settings.email_verification_settings.form.api_url')"
                :is-valid="isFormFieldValid('api_url')"
                maxlength="255"
                @update:value="valueUpdated"
            />
        </DFormRow>
        <DFormRow
            :label="__('settings.email_verification_settings.form.token')"
            :is-required="true"
            :error="errorsData.api_token"
            :hint="__('settings.email_verification_settings.form.token_hint')"
        >
            <DInput
                id="api_token"
                v-model="form.api_token"
                type="password"
                :placeholder="__('settings.email_verification_settings.form.token')"
                :is-valid="isFormFieldValid('api_token')"
                maxlength="255"
                @update:value="valueUpdated"
            />
        </DFormRow>
        <DRow>
            <DCol sm="4" />
            <DCol sm="4">
                <div
                    v-if="connectionStatus === 'successful'"
                    class="green-text"
                >
                    {{ __('settings.email_verification_settings.connection_successful') }}
                </div>
                <div
                    v-if="connectionStatus === 'unsuccessful'"
                    class="red-text"
                >
                    {{ __('settings.email_verification_settings.connection_unsuccessful') }}
                </div>
            </DCol>
            <DCol
                sm="4"
                class="check-database-connection-btn"
            >
                <DButton
                    icon="lan-connect"
                    :label="__('settings.email_verification_settings.check_connection')"
                    :disabled="isInLoadingState"
                    @click="checkConnection"
                />
            </DCol>
        </DRow>
        <DFormControls
            v-show="connectionStatus && credentialsValid"
            :dirty="form.isDirty"
            @submit="submitForm"
        />
        <DConnectionErrorModal
            :show-modal="connectionException !== null"
            :exception="connectionException"
            @close-modal="closeErrorCheckModal"
        />
    </DForm>
</template>

<script setup>

import DConnectionErrorModal from '~@/Components/Common/DConnectionErrorModal'
import { onUpdated, ref } from 'vue'
import { route } from '~@/Composables/route'
import { useForm } from '@inertiajs/vue3'

const props = defineProps({
    emailVerificationSettings: {
        type: Object,
        default: () => { return {} }
    },
    errors: {
        type: Object,
        default: () => ({})
    }
})

const form = useForm({
    api_url: props.emailVerificationSettings?.api_url ?? null,
    api_token: props.emailVerificationSettings?.api_token ?? null,
})

const emit = defineEmits(['form-submitted'])

const connectionStatus = ref(null)
const credentialsValid = ref(false)
const errorsData = ref(props.errors)
const connectionException = ref(null)

onUpdated(() => {
    errorsData.value = props.errors
})

const checkConnection = function () {
    errorsData.value = {}
    connectionException.value = null
    window.axios.post(route('settings.email-verification-settings.check', form))
        .then(function () {
            connectionStatus.value = 'successful'
            credentialsValid.value = true
        })
        .catch(function (error) {
            connectionStatus.value = 'unsuccessful'
            credentialsValid.value = false
            if (error.response.data.error !== undefined) {
                error = error.response.data.error
            }
            if (error.response.data.errors !== undefined) {
                errorsData.value = error.response.data.errors

                for (const key in errorsData.value) {
                    if (typeof errorsData.value[key] === 'object') {
                        errorsData.value[key] = errorsData.value[key][0]
                    }
                }
            }
            if (error?.response.data.exception !== undefined) {
                connectionException.value = error.response.data.exception
            }
        })
}

const submitForm = function () {
    emit('form-submitted', form)
}
const valueUpdated = () => {
    connectionStatus.value = null
}

const closeErrorCheckModal = function () {
    connectionException.value = null
}
</script>

<style lang="scss" scoped>
.check-database-connection-btn {
    text-align: right;
    padding-bottom: 25px;
}
.green-text {
    color: green;
}
.red-text {
    color: red;
}
</style>
